import Box from '@mui/material/Box';
import { TextV2, Dialog } from '@insights-ltd/design-library/components';
import { Trans, useTranslation } from 'react-i18next';
import { styled } from '@mui/material';

export type DownloadingProfilesDialogProps = {
  open: boolean;
  onClose: () => void;
};

const StyledH3 = styled(TextV2)({
  fontSize: '18px !important',
});

const baseUrl =
  import.meta.env.BASE_URL === '/' ? '' : import.meta.env.BASE_URL;

const DialogContent = ({ title }: { title: string }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <img
        src={`${baseUrl}/img/waiting_animation.gif`}
        alt="progress-graphic"
        width={100}
      />
      <Box
        sx={[
          {
            mt: 1,
          },
          (theme) => ({
            color: theme.palette.text.secondary,
          }),
        ]}
      >
        <StyledH3 variant="h3">{title}</StyledH3>
        <Trans
          i18nKey="ui.event-management.events.download-info-dialog.info-description"
          components={{
            styles: (
              <TextV2
                component="span"
                color="textSecondary"
                variant="bodyBold"
              />
            ),
          }}
        />
      </Box>
    </Box>
  );
};

const DownloadingProfilesDialog = ({
  open,
  onClose,
}: DownloadingProfilesDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      title={t('ui.event-management.events.download-info-dialog.title')}
      content={
        <DialogContent
          title={t(
            'ui.event-management.events.download-info-dialog.info-header',
          )}
        />
      }
      secondaryButtonText={t(
        'ui.event-management.events.download-or-share-profiles.confirmation-modal.close',
      )}
      onClose={onClose}
    />
  );
};

export default DownloadingProfilesDialog;
